import * as React from 'react';
import { AgentStatusIndicator } from '../../primitives/status-indicator/status-indicator';
import { namespacedClassnames } from '../../common/namespace-classes';
import { UserAvatar } from '../user-avatar/user-avatar';
export var CallCenterAvatar = function (props) {
    var user = props.user;
    var size = props.size || 'normal';
    var classNames = namespacedClassnames('call-center-avatar', size);
    return (React.createElement("div", { className: classNames },
        React.createElement(UserAvatar, { user: user, size: size, isAgent: true }),
        props.status ? React.createElement(AgentStatusIndicator, { status: props.status, active: props.active, size: size }) : null));
};
//# sourceMappingURL=call-center-avatar.js.map